import { PaginatedRecord } from 'app/API';
import { getCommonAxiosCommon } from 'app/helpers/MiscUtils';
import { NgAPIResponse, NotificationTemplate } from 'app/types';
import axios from 'axios';
import { config } from 'config';

const EndPoints = {
  ListAllTemplates: `${config.vjfpNGRestAPI}/organizations/templates/all`,
  GetTemplate: (templateId: string, channel: string) => `${config.vjfpNGRestAPI}/organizations/templates/${templateId}?channel=${channel}`,
  AddTemplate: `${config.vjfpNGRestAPI}/organizations/templates`,
  UpdateTemplate: (templateId: string, channel: string) => `${config.vjfpNGRestAPI}/organizations/templates/${templateId}?channel=${channel}`,
  TestTemplate: (templateId: string, channel: string) =>
    `${config.vjfpNGRestAPI}/organizations/templates/${templateId}/test?channel=${channel}`
};

export class NotificationTemplateService {
  async listTemplates (): Promise<NotificationTemplate[]> {
    const res = await axios.get<NgAPIResponse<PaginatedRecord<NotificationTemplate[]>>>(EndPoints.ListAllTemplates, await getCommonAxiosCommon());
    if (res.data && res.data.data && res.data.data.items) return res.data.data.items || [];
    return [];
  }

  async getTemplate (templateId: string, channel: string): Promise<NotificationTemplate | null> {
    const res = await axios.get<NgAPIResponse<NotificationTemplate>>(EndPoints.GetTemplate(templateId, channel), await getCommonAxiosCommon());
    if (res.data && res.data.data) return res.data.data;
    return null;
  }

  async addTemplate (template: NotificationTemplate): Promise<NotificationTemplate> {
    const res = await axios.post<NgAPIResponse<NotificationTemplate>>(EndPoints.AddTemplate, template, await getCommonAxiosCommon());
    if (res.data && res.data.data) return res.data.data;
    throw new Error('Failed to add template');
  }

  async updateTemplate (template: NotificationTemplate): Promise<NotificationTemplate> {
    const res = await axios.put<NgAPIResponse<NotificationTemplate>>(EndPoints.UpdateTemplate(template.templateId, template.channel), template, await getCommonAxiosCommon());
    if (res.data && res.data.data) return res.data.data;
    throw new Error('Failed to update template');
  }

  async testTemplate (templateId: string, channel: string, recipient: string, testData: any): Promise<void> {
    const res = await axios.post<NgAPIResponse<void>>(
      EndPoints.TestTemplate(templateId, channel),
      { recipient, testData },
      await getCommonAxiosCommon()
    );
    if (!res.data.isSuccess) throw new Error(res.data.errors?.join(', '));
  }
}
